import ObjectFitImages from "object-fit-images";

const images = document.querySelectorAll(".media-content-block__image");
ObjectFitImages(images);
